<!-- TEMPLATE -->
<template>
  <div class="perspectives-summary">
    <div class='row'>
      <div class='small-12 medium-12 large-12 hd-12 columns dashboard-content'>
        <dean-section-title content='true'>
          <span slot='title'>
              <span class='avenir-heavy'>Logboeken</span>
          </span>
        </dean-section-title>

        <div class="filter">
          <dean-form-row
              @input="update(true)"
              v-model="pageMeta.query"
              class="top-bar"
              :hide-label="true"
          >Filter</dean-form-row>
        </div>

        <dean-table
          :data='logs'
          :columns="columns"
          @column-click='columnClick'
          @cell-click="cellClick"
          :hover="true"
          :showLayoutButtons="true">
        </dean-table>
      </div>
    </div>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
  import { Component } from 'vue-property-decorator';
  import axios from 'axios';
  import deanTableMixin from '@/mixins/deanTableMixin';
  import sideMenuAdminMixin from '@/mixins/sideMenuAdminMixin';
  import {mixins} from 'vue-class-component';

  import {
    // COMPONENTS
    deanSectionTitle,
    deanSectionTitleItem,
    deanTable,
  } from '@deanone/dean-components';
  import DeanIcon from '@/components/deanComponents/deanIcon.vue';
  import deanFormRow from "@/components/deanComponents/deanFormRow.vue";
  import {getDutchDateFormat} from "@/mixins/dateWrapper";

  interface Log {
    filename: string;
    size: string;
    updatedAt: string;
  };

  @Component({
    components: {
      DeanIcon,
      deanFormRow,
      deanSectionTitle,
      deanSectionTitleItem,
      deanTable,
    },
  })

  export default class List extends mixins(deanTableMixin, sideMenuAdminMixin) {
    public sideMenu: object = {
      title: {
        text: 'Logboeken',
        mobile: {
          close: {
            text: 'Close',
          },
        },
      },
      filters: {},
    };

    public queryTimeout!: number;

    // DATA

    private logs: Array<Log> = [];

    public columns: any = {
      filename: {
        content: 'Filename',
        align: 'left',
        sort: false,
        dql: 'filename',
      },
      size: {
        content: 'Size',
        align: 'left',
        sort: false,
        dql: 'size',
      },
      updatedAt: {
        content: 'Updated at',
        align: 'center',
        sort: true,
        dql: 'updatedAt',
      },
    };

    // METHODS
    public loadList() {
      this.$store.dispatch('setLoadOverlay', true);

      axios.post('/-/trade/api/admin.logs.list', {
        'sort': this.pageMeta.sort,
        'filter': this.pageMeta.query,
      })
      .then(
        (response: any) => {
          this.logs = this.logsFactory(response.data.data);
        },
        (error: any) => {
          this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
        },
      ).finally(() => {
        this.$store.dispatch('setLoadOverlay', false);
      });
    }

    private logsFactory(items: object): Array<Log> {
      let logs: Array<Log> = [];

      Object.values(items).forEach((item: any) => {
        let log: Log = {
          filename: item.filename,
          size: (item.size / 1024 / 1024).toFixed(2) + ' MB',
          updatedAt: getDutchDateFormat(item.updatedAt),
        };

        logs.push(log);
      })

      return logs;
    }

    public cellClick(target: {
      cell: object, row: Log, column: string,
    }) {
      this.$router.push({
        name: 'standingData.logs.info',
        params: {filename: target.row.filename},
      });
    }

    public created() {
      this.keepMetaSavedInState();
      this.setDefaultSort('-updatedAt');
      this.loadList();
      this.$store.dispatch('setStandingDataSideMenu', this.sideMenu);
    }

    public update(timeout: boolean|null = null) {
      const self = this;
      const meta: any = self.pageMeta;

      if (timeout) {
        if (this.queryTimeout) {
          clearTimeout(this.queryTimeout);
        }
        this.queryTimeout = setTimeout(() => {
          self.loadList();
        }, 800);
      } else {
        this.loadList();
      }
    }
  }
</script>
<!-- STYLE -->
<style lang="scss" scoped>

.filter {
  display: flex;
}

</style>